var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.75C0 3.91751 3.91751 0 8.75 0H19.25C24.0825 0 28 3.91751 28 8.75V19.25C28 24.0825 24.0825 28 19.25 28H8.75C3.91751 28 0 24.0825 0 19.25V8.75Z",
    fill: "#F1F5F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1256_6692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33594 20.6641H20.6637",
    stroke: "#62748E",
    strokeWidth: 1.33277,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51544 13.1805L7.33594 12.001L8.66871 9.00221L9.40174 9.36872C9.76825 9.55531 10.0015 9.92849 10.0015 10.335C10.0015 10.7415 10.2347 11.1147 10.6012 11.3012L11.3343 11.6678L13.3334 7.66943L14.0331 8.02262C14.2276 8.11947 14.3954 8.26239 14.522 8.43893C14.6486 8.61547 14.7301 8.82028 14.7595 9.03553L15.2393 12.634C15.2686 12.8493 15.3502 13.0541 15.4768 13.2306C15.6034 13.4072 15.7712 13.5501 15.9657 13.6469L18.8978 15.113C19.1776 15.2596 19.4175 15.4795 19.5708 15.7527L19.9706 16.4391C20.2972 17.0255 19.9307 17.7585 19.2643 17.8385L18.4779 17.9385C18.1647 17.9784 17.8449 17.9251 17.565 17.7785L8.86196 13.4337C8.73354 13.3686 8.61651 13.283 8.51544 13.1805Z",
    stroke: "#62748E",
    strokeWidth: 1.33277,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1256_6692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9933,
    height: 15.9933,
    fill: "white",
    transform: "translate(6.00293 6.00342)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/flight.40b69f44c7c1991d49ca8bb256d91379.svg";
export { ForwardRef as ReactComponent };